import { __assign } from "tslib";
import { ChangeLogSelect } from './Changelog';
import { FindOneLogWithLogEntryInclude, LogEntryInclude } from './LogEntry';
import { UserSelect } from './User';
export var LogExportInclude = {
    category: { select: { name: true } },
    location: { select: { name: true } },
    product: { select: { name: true } },
    owner: { select: { email: true } },
};
export var LogInclude = {
    apiTransaction: {
        include: {
            integration: true,
        },
    },
    category: {
        include: {
            scope: true,
            image: true,
            subcategories: true,
        },
    },
    organizationEmissions: {
        where: { deletedAt: null, outOfScope: false },
        include: {
            scope: true,
            factor: true,
        },
    },
    organizationConsumptions: {
        where: { deletedAt: null },
        include: {
            scope: true,
        },
    },
    logEntries: {
        where: { deleted: false },
        orderBy: {
            createdAt: 'asc',
        },
        include: LogEntryInclude,
    },
    changeLogs: {
        where: { deleted: false },
        select: __assign(__assign({}, ChangeLogSelect), { user: {
                select: UserSelect,
            } }),
    },
    files: true,
    location: { include: { businessUnit: true } },
    owner: true,
    organization: true,
    product: {
        include: { businessUnit: true },
    },
};
export var FindOneLogInclude = {
    apiTransaction: {
        include: {
            integration: true,
        },
    },
    category: {
        include: {
            scope: true,
            image: true,
            subcategories: true,
        },
    },
    organizationEmissions: {
        where: { deletedAt: null },
        include: {
            scope: true,
            factor: true
        },
    },
    organizationConsumptions: {
        where: { deletedAt: null },
        include: {
            scope: true,
        },
    },
    logEntries: {
        where: { deleted: false },
        orderBy: {
            createdAt: 'asc',
        },
        include: FindOneLogWithLogEntryInclude,
    },
    changeLogs: {
        where: { deleted: false },
        select: __assign(__assign({}, ChangeLogSelect), { user: {
                select: UserSelect,
            } }),
    },
    files: true,
    location: { include: { businessUnit: true } },
    product: { include: { businessUnit: true } },
    owner: true,
    organization: true,
};
//# sourceMappingURL=Log.js.map